import { render, staticRenderFns } from "./PreviewWrapper.vue?vue&type=template&id=4c9f9a86&scoped=true&"
import script from "./PreviewWrapper.vue?vue&type=script&lang=ts&"
export * from "./PreviewWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewWrapper.vue?vue&type=style&index=0&id=4c9f9a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f9a86",
  null
  
)

export default component.exports